// extracted by mini-css-extract-plugin
export var aboveInput = "_gj-0";
export var actionButton = "_gj-5";
export var actionButtonContainer = "_gj-1";
export var actionIcon = "_gj-6";
export var aiInfoContainer = "_gj-2";
export var attachmentWrapper = "_gj-7";
export var bold = "_gj-3";
export var checkIcon = "_gj-8";
export var clickingRecipientBar = "_gj-11";
export var commentThreadSwitch = "_gj-a";
export var draftImage = "_gj-b";
export var draftImageContainer = "_gj-c";
export var draftImages = "_gj-e";
export var editButton = "_gj-g";
export var editor = "_gj-f";
export var editorContainer = "_gj-y";
export var editorErrorTooltipWrapper = "_gj-9";
export var headerDivider = "_gj-h";
export var icon = "_gj-i";
export var info = "_gj-j";
export var internal = "_gj-n";
export var internalDivider = "_gj-k";
export var internalMessage = "_gj-l";
export var messageInputCard = "_gj-m";
export var messageInputForm = "_gj-o";
export var messageInputFormInternal = "_gj-p";
export var options = "_gj-q";
export var publicMessageCustomer = "_gj-s";
export var publicMessageMerchant = "_gj-r";
export var removeImageButton = "_gj-d";
export var replyButtons = "_gj-t";
export var showSignatureButton = "_gj-u";
export var spinner = "_gj-v";
export var verticalButtonDivider = "_gj-4";
export var visibilitySelector = "_gj-w";
export var warning = "_gj-x";
export var wrappingText = "_gj-z";
export var writingInternalNoteTopBorder = "_gj-10";